import { IconButton } from '../primitives/icon-button.js'
import type { IconButtonProps } from '../primitives/icon-button.js'
import { Close as CloseIcon } from '@tunasong/icons'
import type { MouseEvent } from 'react'

export interface CloseButtonProps extends IconButtonProps {
  onClose: (ev: MouseEvent) => void
}

export const CloseButton = ({ onClose, ...restProps }: CloseButtonProps) => {
  if (!onClose) {
    return null
  }

  return (
    <IconButton
      {...restProps}
      style={{ color: 'var(--tuna-palette-grey-500)', zIndex: 1 }}
      aria-label="close"
      tabIndex={-1}
      onClick={onClose}
    >
      <CloseIcon />
    </IconButton>
  )
}

export default CloseButton
